import React from "react";
import { Form, Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { openModalLogin } from "../../../redux/aspirante/aspiranteDucks";
import FormLogin from "./FormLogin";
import { cleanErrorLogin } from "../../../redux/usuario/usuarioDucks";

export const ModalLogin = () => {
  const [form] = Form.useForm();
  const { modalLogin } = useSelector((state) => state.aspirante);
  const dispatch = useDispatch();

  /**
   *Función para mostrar/ocultar el modal de inicio de sesión
   *
   */
  const openOrCloseModal = () => {
    dispatch(openModalLogin());
    form.resetFields();
    dispatch(cleanErrorLogin());
  };

  return (
    <Modal
      visible={modalLogin}
      onOk={openOrCloseModal}
      onCancel={openOrCloseModal}
      footer={null}
      className="modalLogin"
      keyboard={false}
      maskClosable={false}
      width={450}
    >
      <center>
        {/* Formulario del login */}
        <FormLogin openOrCloseModal={openOrCloseModal} form={form} />
      </center>
    </Modal>
  );
};
